
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.221 14.529a1.723 1.723 0 00-2.6 0c-.608.6-1.218 1.208-1.816 1.82a.358.358 0 01-.5.094c-.393-.216-.813-.39-1.192-.624a18.925 18.925 0 01-4.554-4.144A10.78 10.78 0 016.927 9.06a.374.374 0 01.093-.481c.608-.588 1.2-1.191 1.8-1.795a1.73 1.73 0 000-2.666c-.475-.481-.951-.951-1.428-1.432S6.415 1.7 5.919 1.214a1.733 1.733 0 00-2.6.005c-.613.6-1.2 1.222-1.825 1.816a2.965 2.965 0 00-.932 2 8.466 8.466 0 00.655 3.648 22.15 22.15 0 003.934 6.553c2.21 2.65 4.958 4.8 8.062 6.308a11.7 11.7 0 004.466 1.3 3.28 3.28 0 002.809-1.07c.522-.583 1.11-1.115 1.663-1.673a1.742 1.742 0 00.01-2.65c-.981-.977-1.961-1.95-2.94-2.922z","fill":"#fff"}})])
          )
        }
      }
    